import { ArticleRendererCore } from "../../../website/src/domain/article-renderer";
import type { ArticlePayload, Category, MediaAsset } from "./types";
import { siteNames } from "./types";

type Props = {
  article: ArticlePayload;
  categories: Category[];
  media: MediaAsset[];
  onClose: () => void;
};

export function ArticlePreview({ article, categories, media, onClose }: Props) {
  const legal = article.contentType === "LEGAL";
  const cover = article.cover ? media.find((asset) => asset.id === article.cover?.mediaId) : undefined;
  const category = categories.find((item) => item.id === article.categoryId)?.title ?? article.categoryId;
  const previewSource = (asset: MediaAsset) => asset.src.startsWith("/media/cms/")
    ? `/api/media/${asset.id}/file`
    : `/api/media/bootstrap/${encodeURIComponent(asset.src.split("/").at(-1) ?? "")}`;
  return (
    <div className="preview-backdrop" role="dialog" aria-modal="true" aria-label={legal ? "Предпросмотр юридического документа" : "Предпросмотр статьи"}>
      <div className="preview-window">
        <header><div><small>Предпросмотр оформления {siteNames[article.siteId]}</small><b>Данные ещё не опубликованы</b></div><button type="button" onClick={onClose}>Закрыть ×</button></header>
        <article className="public-article-preview">
          <div className="preview-meta"><span>{legal ? "Юридический документ" : category}</span><time>Предпросмотр</time><span>Черновик</span></div>
          <h1>{article.title || "Заголовок статьи"}</h1>
          <p className="preview-lead">{article.excerpt || "Краткое описание публикации появится здесь."}</p>
          {cover && article.cover ? <figure className="preview-cover"><img src={previewSource(cover)} alt={article.cover.alt} /></figure> : null}
          <div className="preview-body">
            <ArticleRendererCore
              document={article.content}
              media={media}
              renderImage={(asset, alt) => <img src={previewSource(asset as MediaAsset)} alt={alt} width={asset.width} height={asset.height} />}
              renderVideo={(asset, options) => <video src={previewSource(asset as MediaAsset)} poster={options.poster ? previewSource(options.poster as MediaAsset) : undefined} width={asset.width} height={asset.height} controls={options.controls ?? true} loop={options.loop} muted={options.muted ?? true} playsInline />}
            />
          </div>
        </article>
      </div>
    </div>
  );
}
